import {ErrorBoundary} from "@webng/react-app-common";
import React, {ForwardedRef, forwardRef, useEffect, useState} from "react";
import {LiveblogCoreApi} from "../liveblog-core/LiveblogCoreWidgetProps";
import {useMasterElement} from "./useMasterElement";
import {LiveblogPortalWidgetApi, LiveblogPortalWidgetProps} from "./LiveblogPortalWidgetProps";
import {useMediaQuery} from "../../utils/useMediaQuery";

interface LiveblogPortalControllerProps extends LiveblogPortalWidgetProps {
}

function LiveblogPortalControllerImp({ liveblogId, type, media }: LiveblogPortalControllerProps, ref: ForwardedRef<LiveblogPortalWidgetApi>) {
  // const [data, setData] = useState<LiveblogTeaserWidgetInitialData>()
  // const [error] = useState<number|undefined>(undefined)

  const masterElement = useMasterElement(liveblogId)
  const [divRef, setDivRef] = useState<HTMLDivElement|null>(null)

  const matchesMediaQuery = useMediaQuery(media)

  // useEffect(() => {
  //   if (masterElement) {
  //     const updateData = () => {
  //       const coreData = (masterElement as unknown as LiveblogCoreApi).getCurrentLiveblogData()
  //       setData((originalData) => ({
  //         ...originalData,
  //         gameShowResponse: {
  //           _type: "Tik::Model::Api::GameShowResponse",
  //           game: coreData.game,
  //           events: Object.values(coreData.events) as IEvent[]
  //         },
  //         configuration: Object.assign({}, liveblogTeaserThemeConfigurationDefaultValues, sharedThemeConfigurationDefaultValues)
  //       }));
  //     }
  //
  //     masterElement.addEventListener(tickarooLiveblogDataUpdatedEvent, updateData)
  //     updateData()
  //
  //     return () => {
  //       masterElement.removeEventListener(tickarooLiveblogDataUpdatedEvent, updateData)
  //     }
  //   }
  // }, [masterElement]);

  useEffect(() => {
    const finalDivRef = divRef
    const finalMasterElement = masterElement
    if(finalMasterElement && finalDivRef && matchesMediaQuery) {
      (finalMasterElement as unknown as LiveblogCoreApi).registerPortalForType(type, {
        element: divRef
      })

      return () => {
        (finalMasterElement as unknown as LiveblogCoreApi).unregisterPortalForType(type, finalDivRef)
      }
    }
  }, [masterElement, divRef, type, matchesMediaQuery]);

  return <div className="tik4-portal" ref={setDivRef}>

  </div>
}


const LiveblogPortalController = forwardRef(LiveblogPortalControllerImp)

function LiveblogPortalWidgetImp({...props}: LiveblogPortalWidgetProps, ref: ForwardedRef<LiveblogPortalWidgetApi>) {
  return <React.StrictMode>
    <ErrorBoundary>
      <LiveblogPortalController ref={ref} {...props} />
    </ErrorBoundary>
  </React.StrictMode>
}


export const LiveblogPortalWidget = forwardRef(LiveblogPortalWidgetImp)
